import CreateForm from "./pages/CreateForm";
import { addMember } from "../../../api/member";
import { message } from "antd";

export default function UserAdd() {
  const parseRoleId = (roleId) => {
    if (roleId === "1") return "高级管理员";
    if (roleId === "2") return "智慧豆录入员";
    if (roleId === "3") return "智慧豆审核员";
    if (roleId === "4") return "智慧豆录入和审核员";
    return "未知权限";
  };

  const handleAddMember = (memberData, form) => {
    try {
      const response = addMember(memberData, form);
    } catch (error) {
      console.error("Error adding member:", error);
    }
  };

  return (
    <div>
      <CreateForm handleAddMember={handleAddMember} parseRoleId={parseRoleId} />
    </div>
  );
}
